package com.stiv_apps.facecutweb.components

import androidx.compose.runtime.Composable
import com.stiv_apps.facecutweb.style.LogoStyle
import com.stiv_apps.facecutweb.util.Resource
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Header(
    largeBreakpoint: Boolean,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                top = if (largeBreakpoint) 25.px else 50.px,
                bottom = if (largeBreakpoint) 0.px else 50.px
            ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = if (largeBreakpoint) Arrangement.Start
        else Arrangement.Center
    ) {
        Image(
            modifier = LogoStyle.toModifier()
                .size(size = 80.px)
                .cursor(Cursor.Pointer),
            src = Resource.Icon.LOGO,
            alt = "Logo Image"
        )
    }
}
